// apps/embed/src/chat-widget/chatStringsToFetch.ts
//
// The translation keys the website chat widget fetches at mount (POST
// /v1/.../locales/{lang}/strings). Kept SEPARATE from the booking storefront's
// stringsToFetch so the lightweight chat bundle doesn't pull the full storefront
// dictionary. Every key here must exist in the common TypeScript catalog or getStr renders
// the `NO STRING IMPORTED…` placeholder. Some keys are shared with the backoffice chat.
import type { CommonKey } from '@tourtask/i18n/keys';
import { ORIGIN_NOT_ALLOWED_KEYS } from '@tourtask/storefront/components/general/originNotAllowedKeys';
export const CHAT_STRINGS_TO_FETCH = [
  // A page the business has not registered: the panel's "This website is not
  // registered with TourTask" (`WidgetErrorAlert`).
  ...ORIGIN_NOT_ALLOWED_KEYS,
  'Chat_with_us',
  'How_can_we_help',
  'Your_name',
  'Your_email',
  'Your_phone',
  'Your_message',
  'Phone_country',
  'Please_fill_out_this_field',
  'Email_invalid',
  'This_field_is_too_long',
  'Start_chat',
  'Send',
  'Type_your_message',
  'No_messages_yet',
  'Support_online',
  'Support_offline',
  'We_are_online',
  'We_are_currently_offline',
  'X_entered_the_chat',
  'Handover_requested',
  'This_conversation_is_closed',
  'Start_a_new_conversation',
  'Chat_could_not_be_started',
  'Close',
  // Email-only fallback (both AI + human support off, but a contact email exists):
  // a "leave a message" form that posts to /contact-requests.
  'Leave_a_message_INFO',
  'Message_sent',
  'CONTACT_US_RECEIVED_INFO',
  'Your_message_could_not_be_sent',
  // Frozen account (unpaid TourTask invoices): the whole widget is disabled and
  // shows this notice instead of any chat / leave-a-message form.
  'WEBSITE_CHAT_DISABLED_UNPAID_INVOICES_INFO',
	// The shared conversation pane (packages/ui/src/components/chat/ChatMessageList.tsx),
	// which the embed chat widget renders directly.
	'Read',
	'Unread',
	'Handover_summary',
] as const satisfies readonly CommonKey[];
